<!--  第三方监控对接页面  -->
<template>
    <div>
      <Row>
        <Input size="small" search @on-search="onFilterClick" v-model="keywordFilter" clearable placeholder="名称/联系电话/联系地址"
               style="width: 200px; margin-right: 3px;"></Input>
        <DatePicker size="small" type="daterange" v-model="selectCreateDatetime" placeholder="选择日期"
                    style="margin-right: 3px; width: 200px;"></DatePicker>
        <Button size="small" type="primary" style="margin-right: 3px;" @click="onFilterClick">查询</Button>
        <Button size="small" type="primary" style="margin-right: 3px;" @click="addMonitoringServiceOrderModal=true">添加第三方监控订单</Button>
        <Upload style="display: inline-block;max-height: 23.99px;margin-right: 3px;" :on-success="onModifySuccess"
                action="/api/om/monitoringserviceorder/importorders">
          <Button size="small" type="primary">批量导入订单</Button>
        </Upload>
<!--        <Button type="primary" size="small" @click="onExportExcel">导出报表</Button>-->

        <Button type="primary" size="small" style="margin-right: 3px;" @click="monitoringServiceConfirmMonitoringModal = true">批量对接</Button>

      </Row>

      <Row style="margin-top: 3px;">
        <div style="width: 100%;">
          <div style="position:relative;">
            <context-menu ref="contextMenuRef" :menuList="menuList" @callback="onContextMenuCallback"></context-menu>
            <Table border highlight-row size="small" height="600" :columns="columns" :stripe="true" :data="content"
                   ref="table"
                   :height="tableHeight"
                   @on-sort-change="sortChange" @contextmenu.prevent.native="onTableRightClick($event)"
                   @on-selection-change="onselectionchange">
            </Table>
            <div style="position:absolute;top:0px;width:100%;height:100%;display: flex;
                            align-items: center;
                            justify-content: center;background: rgba(210, 216, 222, 0.5);" v-if="listLoadding">
              <Spin size="large"></Spin>
              <h6 style="color:#2d8cf0;margin-top:10px;">正在获取数据...</h6>
            </div>
          </div>
          <Page size="small" :total="totalElements" :page-size="pageSize" :current="pageIndex" :show-total="true" show-elevator
                @on-change="setPage"
                show-sizer @on-page-size-change="refreshPage" :page-size-opts="pagesizeopts"
                style="text-align:right;margin-top:3px;"></Page>

        </div>
      </Row>

      <web-table-columns-modal v-model="webTableColumnsModal" :columnList.sync="columns" :tableName="$options.name"
                               @on-column-update="onColumnUpdate"></web-table-columns-modal>

      <add-monitoring-service-order-modal v-model="addMonitoringServiceOrderModal" @on-success="onSuccess"></add-monitoring-service-order-modal>
      <bind-monitoring-service-positioning-devices-modal v-model="bindMonitoringServicePositioningDevicesModal" :initValue="bindMonitoringServicePositioningDevicesId"
                                                         @on-success="onModifySuccess"></bind-monitoring-service-positioning-devices-modal>
      <monitoring-service-order-change-business-user-modal v-model="monitoringServiceOrderChangeBusinessUserModal" :initValue="monitoringServiceOrderChangeBusinessUserId"
                                                           @on-success="onModifySuccess"></monitoring-service-order-change-business-user-modal>
      <monitoring-service-order-confirm-recept-modal v-model="monitoringServiceOrderConfirmReceptModal" :initValue="monitoringServiceOrderConfirmReceptId"
                                               @on-success="onModifySuccess"></monitoring-service-order-confirm-recept-modal>
      <monitoring-service-confirm-monitoring-modal v-model="monitoringServiceConfirmMonitoringModal" :initValue="monitoringServiceConfirmMonitoringId" :listValue="orderList"
                                                   @on-success="onModifySuccess"></monitoring-service-confirm-monitoring-modal>
      <monitoring-service-order-base-modal v-model="mnitoringServiceOrderBaseModal" :initValue="mnitoringServiceOrderBaseId"
                                           @on-success="onModifySuccess"></monitoring-service-order-base-modal>
      <monitoring-service-order-detail-modal v-model="monitoringServiceOrderDetailModal" :initValue="monitoringServiceOrderDetailId"
                                             @on-success="onModifySuccess"></monitoring-service-order-detail-modal>

      <vehicle-info-detail-modal v-model="vehicleInfoDetailModal" :initValue="vehicleInfoDetailId"
                                 @on-success="onModifySuccess"></vehicle-info-detail-modal>

    </div>
</template>

<script>

import AddMonitoringServiceOrderModal from '@/view/om/components/add-monitoring-service-order-modal'
import BindMonitoringServicePositioningDevicesModal from '@/view/om/components/bind-monitoring-service-positioning-devices-modal'
import MonitoringServiceOrderChangeBusinessUserModal from '@/view/om/components/monitoring-service-order-change-business-user-modal'
import MonitoringServiceOrderConfirmReceptModal from '@/view/om/components/monitoring-service-order-confirm-recept-modal'
import MonitoringServiceConfirmMonitoringModal from '@/view/om/components/monitoring-service-confirm-monitoring-modal'
import MonitoringServiceOrderBaseModal from '@/view/om/components/monitoring-service-order-base-detail-modal'
import MonitoringServiceOrderDetailModal from '@/view/om/components/monitoring-service-order-detail-modal'

import VehicleInfoDetailModal from '@/view/crm/components/vehicle-info-detail-modal'

import Vue from 'vue'
import store from '@/store'
import { mapActions } from 'vuex'
import { genQueryParam, genSortParam } from '@/libs/queryparamhelper'
import { numberFormat } from '@/libs/numberutil'
import { genURLParams } from '@/libs/urlparamhelper'
import axios from '@/libs/api.request'

export default {
  name: 'connectmonitoringserviceorder',
  components: {
    AddMonitoringServiceOrderModal,
    BindMonitoringServicePositioningDevicesModal,
    MonitoringServiceOrderChangeBusinessUserModal,
    MonitoringServiceOrderConfirmReceptModal,
    MonitoringServiceConfirmMonitoringModal,
    MonitoringServiceOrderBaseModal,
    MonitoringServiceOrderDetailModal,
    VehicleInfoDetailModal
  },
  data () {
    return {
      // 添加第三方监控订单
      addMonitoringServiceOrderModal: false,

      // 绑定设备到第三方监控订单
      bindMonitoringServicePositioningDevicesModal: false,
      bindMonitoringServicePositioningDevicesId: null,

      // 指派第三方监控业务员
      monitoringServiceOrderChangeBusinessUserModal: false,
      monitoringServiceOrderChangeBusinessUserId: null,

      // 第三方监控确认收款
      monitoringServiceOrderConfirmReceptModal: false,
      monitoringServiceOrderConfirmReceptId: null,

      // 第三方监控确认对接订单
      monitoringServiceConfirmMonitoringModal: false,
      monitoringServiceConfirmMonitoringId: null,

      // 修改第三方监控基础订单信息
      mnitoringServiceOrderBaseModal: false,
      mnitoringServiceOrderBaseId: null,

      // 第三方监控详细信息
      monitoringServiceOrderDetailModal: false,
      monitoringServiceOrderDetailId: null,

      // 车辆信息
      vehicleInfoDetailModal: false,
      vehicleInfoDetailId: null,

      // 表格右击组件
      webTableColumnsModal: false,
      menuList: [
        { title: '设置表格列', content: {} }
      ],

      // 筛选条件
      businessUserFilter: null,

      // 业务员和安装员
      installers: [],
      marketsales: [],

      // 查询关键字
      keywordFilter: null,

      // 时间选择器
      selectCreateDatetime: [],

      // 表格高度
      tableHeight: 160,

      // 表格加载loading
      listLoadding: false,

      // 分页组件
      // 页数
      pageIndex: 1,
      // 每页数量
      pagesizeopts: [30, 50, 100, 200],

      // 表格列
      columns: [
        {
          type: 'selection',
          width: 60,
          align: 'center'
        },
        {
          title: '订单号',
          resizable: true,
          key: 'orderNum',
          sortable: 'custom',
          width: 180
        },
        {
          title: '车辆信息',
          resizable: true,
          tooltip: 'true',
          ellipsis: 'true',
          width: 190,
          render: (h, params) => {
            let registrationNum = ''
            let identificationCode = ''
            let vin = ''
            if (params.row.vehicleInfo) {
              registrationNum = params.row.vehicleInfo.registrationNum === null ? '无' : params.row.vehicleInfo.registrationNum
              identificationCode = params.row.vehicleInfo.identificationCode === null ? '无' : params.row.vehicleInfo.identificationCode
              vin = params.row.vehicleInfo.vin === null ? '无' : params.row.vehicleInfo.vin
            } else {
              registrationNum = params.row.monitoringServiceTempVehicleInfo.registrationNum === null ? '无' : params.row.monitoringServiceTempVehicleInfo.registrationNum
              identificationCode = params.row.monitoringServiceTempVehicleInfo.identificationCode === null ? '无' : params.row.monitoringServiceTempVehicleInfo.identificationCode
              vin = params.row.monitoringServiceTempVehicleInfo.vin === null ? '无' : params.row.monitoringServiceTempVehicleInfo.vin
            }
            return h('div', [
              h('div', '车牌:' + registrationNum + '(识别码:' + identificationCode + ')'),
              h('div', '车架号:' + vin)
            ])
          }
        },
        {
          title: '客户/分组名',
          resizable: true,
          key: 'clientInfo',
          sortable: 'custom',
          ellipsis: 'true',
          width: 180,
          render: (h, params) => {
            let display = []
            if (params.row.vehicleInfo) {
              if (params.row.clientInfo) {
                display.push(h('div', '客户信息:' + params.row.clientInfo.name + '(' + params.row.clientInfo.phoneNum + ')'))
              } else {
                display.push(h('div', '客户信息:无'))
              }
              if (params.row.vehicleInfo.vehicleInfoGroup) {
                display.push(h('div', '分组:' + params.row.vehicleInfo.vehicleInfoGroup.name))
              } else {
                display.push(h('div', '分组:无'))
              }
              return h('div', display)
            } else {
              if (params.row.clientInfo) {
                display.push(h('div', '客户信息:' + params.row.clientInfo.name + '(' + params.row.clientInfo.phoneNum + ')'))
              } else {
                display.push(h('div', '客户信息:无'))
              }
              if (params.row.vehicleInfoGroup) {
                display.push(h('div', '分组:' + params.row.vehicleInfoGroup.name))
              } else {
                display.push(h('div', '分组:无'))
              }
              return h('div', display)
            }
          }
        },
        {
          title: '订单状态',
          resizable: true,
          key: 'state',
          tooltip: 'true',
          ellipsis: 'true',
          width: 120,
          filters: [
            { label: '对接', value: 1 },
            { label: '完成', value: 2 },
            { label: '作废', value: 0 },
            { label: '异常', value: -1 },
            { label: '审核', value: 3 },
            { label: '回访', value: 4 },
            { label: '收款', value: 5 }
          ],
          filterMultiple: true,
          filteredValue: [1],
          filterRemote: (val) => {
            if (val && val.length > 0) {
              this.stateFilter = []
              val.forEach(item => {
                this.stateFilter.push(genQueryParam('state', 'EQ', item))
              })
            } else {
              this.stateFilter = null
            }
            this.setPage(1)
          },
          render: function (h, params) {
            let state = params.row.state
            let step = null
            if (params.row.step != null) {
              step = params.row.step.state
            } else {
              step = 1
            }
            if (state === 1) {
              if (step === 0) {
                return h('div', '作废')
              } else if (step === 1) {
                return h('div', '待对接')
              } else if (step === 2) {
                return h('div', '已对接')
              } else if (step === 3) {
                return h('div', '对接失败')
              }
            } else if (state === 2) {
              return h('div', '完成')
            } else if (state === 0) {
              return h('div', '作废')
            } else if (state === -1) {
              return h('div', '异常')
            } else if (state === 3) {
              if (step === 0) {
                return h('div', '作废')
              } else if (step === 1) {
                return h('div', '审核中')
              } else if (step === 2) {
                return h('div', '审核通过')
              } else if (step === 3) {
                return h('div', '审核不通过')
              }
            } else if (state === 4) {
              if (step === 0) {
                return h('div', '作废')
              } else if (step === 1) {
                return h('div', '待回访')
              } else if (step === 2) {
                return h('div', '已回访')
              } else if (step === 3) {
                return h('div', '回访失败')
              }
            } else if (state === 5) {
              if (step === 0) {
                return h('div', '作废')
              } else if (step === 1) {
                return h('div', '待收款')
              } else if (step === 2) {
                return h('div', '已收款')
              } else if (step === 3) {
                return h('div', '收款失败')
              }
            }
          }
        },
        {
          title: '结果',
          resizable: true,
          tooltip: 'true',
          ellipsis: 'true',
          width: 160,
          render: (h, params) => {
            if (params.row.step != null) {
              if (params.row.step.result) {
                return h('div', {
                  style: {
                    color: 'red'
                  }
                }, params.row.step.result)
              } else {
                return h('div', {
                  style: {
                    color: 'green'
                  }
                }, '无')
              }
            }
          }
        },
        {
          title: '确认对接时间',
          resizable: true,
          key: 'monitoringDatetime',
          ellipsis: 'true',
          tooltip: 'true',
          width: 180,
          filters: [
            { label: '未确认', value: 0 },
            { label: '已确认', value: 1 }
          ],
          filterMultiple: false,
          filterRemote: (val) => {
            if (val && val.length > 0) {
              if (val[0] === 1) {
                this.receptFilter = genQueryParam('monitoringDatetime', 'NNULL', null)
              } else {
                this.receptFilter = genQueryParam('monitoringDatetime', 'EQNULL', null)
              }
            } else {
              this.receptFilter = null
            }
            this.setPage(1)
          },
          render: function (h, params) {
            if (params.row.monitoringDatetime) {
              let d = new Date(params.row.monitoringDatetime)
              return h('div', d.Format('yyyy年MM月dd日 hh:mm:ss'))
            } else {
              return h('div', {
                style: {
                  color: 'red'
                }
              }, '未确认')
            }
          }
        },
        {
          title: '订单类型',
          resizable: true,
          key: 'monitoringServicePackage',
          tooltip: 'true',
          ellipsis: 'true',
          width: 120,
          filters: [
            { label: '基础版', value: 1 },
            { label: '标准版', value: 2 },
            { label: '专业版', value: 3 }
          ],
          filterMultiple: true,
          filterRemote: (val) => {
            if (val && val.length > 0) {
              this.PackageFilter = []
              val.forEach(item => {
                this.PackageFilter.push(genQueryParam('billType', 'EQ', item))
              })
            } else {
              this.PackageFilter = null
            }
            this.setPage(1)
          },
          render: (h, params) => {
            let monitoringServicePackage = params.row.monitoringServicePackage
            if (monitoringServicePackage === 1) {
              return h('div', '基础版')
            } else if (monitoringServicePackage === 2) {
              return h('div', '标准版')
            } else if (monitoringServicePackage === 3) {
              return h('div', '专业版')
            } else {
              return h('div', '无')
            }
          }
        },
        // {
        //   title: '应收总金额',
        //   resizable: true,
        //   key: 'totalAmount',
        //   tooltip: 'true',
        //   ellipsis: 'true',
        //   width: 100
        // },
        // {
        //   title: '开票类型',
        //   resizable: true,
        //   key: 'billType',
        //   width: 140,
        //   filters: [
        //     { label: '增值税发票', value: 1 },
        //     { label: '增值税专用发票', value: 2 },
        //     { label: '增值税普通发票', value: 3 },
        //     { label: '增值税电子专用发票', value: 4 },
        //     { label: '增值税电子普通发票', value: 5 },
        //   ],
        //   filterMultiple: true,
        //   filterRemote: (val) => {
        //     if (val && val.length > 0) {
        //       this.billTypeFilter = []
        //       val.forEach(item => {
        //         this.billTypeFilter.push(genQueryParam('billType', 'EQ', item))
        //       })
        //     } else {
        //       this.billTypeFilter = null
        //     }
        //     this.setPage(1)
        //   },
        //   render: (h, params) => {
        //     let billType = params.row.billType
        //     if (billType === 1) {
        //       return h('div', '增值税发票')
        //     } else if (billType === 2) {
        //       return h('div', '增值税专用发票')
        //     } else if (billType === 3) {
        //       return h('div', '增值税普通发票')
        //     } else if (billType === 4) {
        //       return h('div', '增值税电子专用发票')
        //     } else if (billType === 5) {
        //       return h('div', '增值税电子普通发票')
        //     }
        //   }
        // },
        // {
        //   title: '收款时间',
        //   resizable: true,
        //   key: 'receptDatetime',
        //   ellipsis: 'true',
        //   tooltip: 'true',
        //   width: 180,
        //   filters: [
        //     { label: '未收款', value: 0 },
        //     { label: '已收款', value: 1 }
        //   ],
        //   filterMultiple: false,
        //   filterRemote: (val) => {
        //     if (val && val.length > 0) {
        //       if (val[0] === 1) {
        //         this.receptFilter = genQueryParam('receptDatetime', 'NNULL', null)
        //       } else {
        //         this.receptFilter = genQueryParam('receptDatetime', 'EQNULL', null)
        //       }
        //     } else {
        //       this.receptFilter = null
        //     }
        //     this.setPage(1)
        //   },
        //   render: function (h, params) {
        //     if (params.row.receptDatetime) {
        //       let d = new Date(params.row.receptDatetime)
        //       return h('div', d.Format('yyyy年MM月dd日 hh:mm:ss'))
        //     } else {
        //       return h('div', {
        //         style: {
        //           color: 'red'
        //         }
        //       }, '未收款')
        //     }
        //   }
        // },
        {
          title: '服务到期时间',
          resizable: true,
          key: 'serviceDatetime',
          sortable: 'custom',
          ellipsis: 'true',
          tooltip: 'true',
          width: 180,
          render: function (h, params) {
            if (params.row.serviceDatetime) {
              let d = new Date(params.row.serviceDatetime)
              return h('div', d.Format('yyyy年MM月dd日'))
            }
          }
        },
        {
          title: '跟进业务员',
          resizable: true,
          key: 'businessUserId',
          ellipsis: 'true',
          tooltip: 'true',
          width: 180,
          filters: [],
          filterMultiple: true,
          filterRemote: (val) => {
            if (val && val.length > 0) {
              this.businessUserFilter = []
              val.forEach(item => {
                this.businessUserFilter.push(genQueryParam('businessUserId', 'EQ', item))
              })
            } else {
              this.businessUserFilter = null
            }
            this.setPage(1)
          },
          render: function (h, params) {
            if (params.row.businessUser) {
              let name = null
              if (params.row.businessUser.realName) {
                name = params.row.businessUser.realName
              } else if (params.row.businessUser.nickName) {
                name = params.row.businessUser.nickName
              } else if (params.row.businessUser.name) {
                name = params.row.businessUser.name
              }
              return h('div', name)
            }
          }
        },
        {
          title: '创建时间',
          resizable: true,
          sortable: 'custom',
          ellipsis: 'true',
          tooltip: 'true',
          key: 'createDatetime',
          width: 180,
          render: function (h, params) {
            if (params.row.createDatetime) {
              let d = new Date(params.row.createDatetime)
              return h('div', d.Format('yyyy年MM月dd日 hh:mm:ss'))
            }
          }
        },
        {
          title: '操作',
          resizable: true,
          key: 'action',
          align: 'left',
          ellipsis: 'true',
          minWidth: 340,
          fixed: 'right',
          render: (h, params) => {
            let display = []
            if (params.row.vehicleInfoId) {
              display.push(
                h('Button', {
                  props: {
                    type: 'primary',
                    size: 'small',
                    disabled: false
                  },
                  style: {
                    marginRight: '5px'
                  },
                  on: {
                    click: () => {
                      this.mnitoringServiceOrderBaseId = params.row.id
                      this.mnitoringServiceOrderBaseModal = true
                    }
                  }
                }, '订单信息')
              )
              display.push(
                h('Button', {
                  props: {
                    type: 'primary',
                    size: 'small',
                    disabled: false
                  },
                  style: {
                    marginRight: '5px'
                  },
                  on: {
                    click: () => {
                      this.vehicleInfoDetailId = params.row.vehicleInfoId
                      this.vehicleInfoDetailModal = true
                    }
                  }
                }, '车辆信息')
              )
            } else {
              display.push(
                h('Button', {
                  props: {
                    type: 'primary',
                    size: 'small',
                    disabled: false
                  },
                  style: {
                    marginRight: '5px'
                  },
                  on: {
                    click: () => {
                      this.monitoringServiceOrderDetailId = params.row.id
                      this.monitoringServiceOrderDetailModal = true
                    }
                  }
                }, '详细信息')
              )
            }

            display.push(
              h('Button', {
                props: {
                  type: 'primary',
                  size: 'small',
                  disabled: false
                },
                style: {
                  marginRight: '5px'
                },
                on: {
                  click: () => {
                    this.handleSelectAll(false)
                    this.monitoringServiceConfirmMonitoringId = params.row.id
                    this.monitoringServiceConfirmMonitoringModal = true
                  }
                }
              }, '订单对接')
            )

            return h('div', display)
          }
        }
      ], // cloumn

      orderList: [],
      orderIds: [],
      orderListstepstate: null,
      orderListstepresult: null
    }
  },
  methods: {
    /**
         * 批量选择功能
         */
    onselectionchange (selection) {
      // console.log(selection)
      this.orderList = selection
      if (selection.length > 0) {
        selection.forEach(item => {
          this.orderIds.push(item.id)
        })
      } else {
        this.orderIds = []
      }
      // console.log(this.installOrderList.length)
    },
    handleSelectAll (status) {
      this.$refs.table.selectAll(status)
    },
    /**
         * 右键菜单点击回调
         */
    onContextMenuCallback (item) {
      if (item.title === '设置表格列') {
        this.webTableColumnsModal = true
      }
    },
    /**
         * 表格筛选功能
         */
    onColumnUpdate () {
      for (let i = 0; i < this.columns.length; i++) {
        if (this.columns[i].title === '跟进业务员') {
          this.columns[i].filters = this.marketsales
          break
        }
      }
      for (let i = 0; i < this.columns.length; i++) {
        if (this.columns[i].title === '安装员') {
          this.columns[i].filters = this.installers
          break
        }
      }
    },
    // 表格排序
    sortChange ({ column, key, order }) {
      this.sort = {
        name: key,
        asc: order === 'asc'
      }
      this.refreshPage()
    },
    /**
         * 表格右键回调
         */
    onTableRightClick (e) {
      this.$refs.contextMenuRef.showMenu(e, this.$el, 0, -20)
    },
    onSuccess () {
      this.setPage(1)
    },
    onModifySuccess () {
      this.handleSelectAll(false)
      this.refreshPage(this.pageFilter)
    },
    onFilterClick () {
      this.setPage(1)
    },
    // 刷新当前页
    refreshPage (value) {
      this.pageFilter = value
      this.setPage(this.pageIndex)
    },
    // 获取数据
    setPage (page) {
      console.log('setPage' + page)
      this.pageIndex = page
      this.listLoadding = true

      let qo1 = null
      let qo2 = null
      let qo3 = null
      let qo4 = null
      let qo5 = null
      let qo6 = null
      let qo7 = null
      let qo8 = null
      let qo9 = null
      let queryParams = []
      let sortParam = null

      if (this.sort) {
        sortParam = genSortParam(this.sort.name, this.sort.asc)
      } else {
        sortParam = genSortParam('createDatetime', false)
      }
      if (this.stateFilter) {
        qo1 = this.stateFilter
      } else {
        qo1 = [genQueryParam('state', 'EQ', 1)
        ]
      }
      if (this.installedFilter) {
        queryParams.push(this.installedFilter)
      }
      if (this.qghyptOptionFilter) {
        qo2 = this.qghyptOptionFilter
      }
      if (this.uploadStateFilter) {
        qo3 = this.uploadStateFilter
      }
      if (this.receptFilter) {
        queryParams.push(this.receptFilter)
      }
      if (this.installerFilter) {
        qo4 = this.installerFilter
      }
      if (this.businessUserFilter) {
        qo5 = this.businessUserFilter
      }
      if (this.billTypeFilter) {
        qo6 = this.billTypeFilter
      }
      if (this.gdcdgovVehicleStateFilter) {
        qo7 = this.gdcdgovVehicleStateFilter
      }
      if (this.salesChannelFilter) {
        qo8 = this.salesChannelFilter
      }
      if (this.isfreeTypeFilter) {
        qo9 = this.isfreeTypeFilter
      }
      if (this.selectCreateDatetime[0] && this.selectCreateDatetime[1]) {
        let startDatetime = new Date(this.selectCreateDatetime[0]).Format('yyyy-MM-dd 00:00:00')
        let endDatetime = new Date(this.selectCreateDatetime[1]).Format('yyyy-MM-dd 23:59:59')
        queryParams.push(genQueryParam('createDatetime', 'BTDT', startDatetime, endDatetime))
      }

      store.dispatch('MonitoringServiceOrderServ_GetPage', {
        params: null,
        urlparams: {
          q: queryParams,
          qo1: qo1,
          qo2: qo2,
          qo3: qo3,
          qo4: qo4,
          qo5: qo5,
          qo6: qo6,
          qo7: qo7,
          qo8: qo8,
          qo9: qo9,
          ps: this.pageFilter,
          p: page,
          keyword: this.keywordFilter,
          sort: sortParam
        }
      }).then(() => {
        this.listLoadding = false
      }).catch(err => {
        this.listLoadding = false
        this.$Message.error(err)
      })
    }
  },
  computed: {
    // computeCol() {
    //   let columns = this.columns
    //   columns = columns.filter(col => {
    //     for (var i = 0; i < this.columnsDisplay.length; i++) {
    //       if (this.columnsDisplay[i] === col.title) {
    //         return true
    //       }
    //     }
    //     return false
    //   })
    //   return columns
    // },
    totalElements () {
      if (store.getters.get_MonitoringServiceOrder_GetPageResult) {
        return store.getters.get_MonitoringServiceOrder_GetPageResult.totalElements
      } else {
        return 0
      }
    },
    content () {
      if (store.getters.get_MonitoringServiceOrder_GetPageResult) {
        return store.getters.get_MonitoringServiceOrder_GetPageResult.content
      } else {
        return []
      }
    },
    pageSize () {
      if (store.getters.get_MonitoringServiceOrder_GetPageResult) {
        return store.getters.get_MonitoringServiceOrder_GetPageResult.size
      } else {
        return 0
      }
    }
  },
  mounted () {
    this.$nextTick(() => {
      // 获取销售员及安装员
      store.dispatch('UserServ_GetAllUsers', {
        params: {},
        urlparams: { roleIds: [8, 14] }
      }).then(() => {
        let installers = store.getters.get_User_GetAllUsersResult
        this.installers = installers.map(item => {
          return { label: item.realName, value: item.id }
        })
        store.dispatch('UserServ_GetAllUsers', {
          params: {},
          urlparams: { roleIds: [7] }
        }).then(() => {
          let marketsales = store.getters.get_User_GetAllUsersResult
          this.marketsales = marketsales.map(item => {
            return { label: item.realName, value: item.id }
          })
          // this.columns[4].filters = this.installers
          // this.columns[13].filters = this.marketsales
          this.onColumnUpdate()
        }).catch(err => {
          this.$Message.error(err)
        })
      }).catch(err => {
        this.$Message.error(err)
      })

      this.tableHeight = window.innerHeight - this.$refs.table.$el.offsetTop - 140
      window.onresize = () => {
        this.tableHeight = window.innerHeight - this.$refs.table.$el.offsetTop - 140
      }

      this.setPage(1)
    })
  }
}
</script>

<style scoped>

</style>
